import Reveal from "@/components/Reveal";

const photos = [
  {
    src: "/gallery-torta.webp",
    alt: "Ospite sorridente durante una festa al Club",
    span: "md:col-span-4",
  },
  {
    src: "/gallery-volo.webp",
    alt: "La festeggiata sollevata dagli amici in pista",
    span: "md:col-span-4",
  },
  {
    src: "/gallery-ballo.webp",
    alt: "Proposta di matrimonio a sorpresa durante una festa al Club",
    span: "md:col-span-4",
  },
  {
    src: "/gallery-pista.webp",
    alt: "Ospiti che ballano abbracciati in pista",
    span: "md:col-span-4",
  },
  {
    src: "/gallery-gruppo.webp",
    alt: "Foto di gruppo con gli ospiti sotto le luci verdi del Club",
    span: "md:col-span-4",
  },
  {
    src: "/gallery-torta50.jpg",
    alt: "Taglio della torta dei 50 anni con fontane luminose",
    span: "md:col-span-4",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="bg-deepblue px-6 py-28 md:py-40 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="mb-6 flex items-center gap-4 text-xs font-medium uppercase tracking-[0.35em] text-dusty">
            <span className="h-px w-10 bg-dusty/70" /> Gallery
          </p>
          <h2 className="max-w-2xl font-serif text-4xl leading-tight tracking-tight text-linen sm:text-5xl md:text-6xl">
            Istanti di <span className="italic text-dusty">luce blu</span>.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-12">
          {photos.map((p, i) => (
            <Reveal key={p.src} delay={(i % 3) * 0.1} className={p.span}>
              <div className="group relative h-72 overflow-hidden md:h-full md:min-h-[300px]" data-testid={`gallery-item-${i + 1}`}>
                <img
                  src={p.src}
                  alt={p.alt}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-[#060607]/10 transition-colors duration-500 group-hover:bg-[#060607]/0" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
